import { Button, Checkbox, Divider, Empty, Select } from "antd";
import { QFTitle } from "@qualitas/qf-title";
import StepsButtons from "../CommonComponents/StepsButtons";
import { CloseOutlined, PlusCircleOutlined } from "@ant-design/icons";
import FormInput from "../CommonComponents/FormInput";
import FormSelect from "../CommonComponents/FormSelect";
import { IPhysicalPersonContactsProps } from "../IDataCollection";

const PhysicalPersonContacts = (props: IPhysicalPersonContactsProps) => {
  const {
    selectedInvestor,
    translations,
    goBackStep,
    onChangeInvestor,
    onAddItem,
    onRemoveItem,
    advanceStep,
    handleAutocompleteContacts,
	errors,
	communicationTypes,
	language
  } = props;

  return (
    <div className="investor-step">
      <label className="investor-select">{translations.inversor}:</label>
      <Select
        style={{ width: "100%" }}
        placeholder={selectedInvestor?.institutionLong}
        disabled
      />
      <Divider />
      <div className="investor-step-header">
        <QFTitle title={translations.contacts} size="extrabig" />
        <Button
          icon={<PlusCircleOutlined />}
          onClick={() => onAddItem("contacts")}
        >
          {translations?.add}
        </Button>
      </div>
      <div>
		<p className="contacts-disclaimer">{translations.contactsDisclaimer}</p>
        {selectedInvestor.signatories.map((person: any, index: number) => {
          const isInContacts = selectedInvestor.contacts.some(
            (contact: any) => contact.documentNumber === person.documentNumber
          );

          return (
            <div key={index} className="contact-selection-row">
              <Checkbox
                checked={isInContacts}
                onChange={(e) =>
                  handleAutocompleteContacts(e.target.checked, person)
                }
              >
                <b>{person.name} {person.firstLastName} {person.secondLastName}</b> {translations.isContact}
              </Checkbox>
            </div>
          );
        })}
        {selectedInvestor?.contacts?.length > 0 &&
          selectedInvestor?.contacts.map((owner: any, index: number) => {
            return (
              <div key={index}>
                <Divider />
                <p className="investor-step-title">
                  {translations.contactData} {index + 1}
                  <Button
                    type="text"
                    icon={<CloseOutlined />}
                    onClick={() => onRemoveItem("contacts", index)}
					disabled={selectedInvestor?.contacts?.length === 1}
                />
                </p>
                <div className="investor-step-form-row">
                  <FormInput
                    mandatory
                    field="name"
                    onChangeInvestor={(value: any, field: any) =>
                      onChangeInvestor(value, field, index, "contacts")
                    }
                    value={owner?.name || ""}
                    label={translations.names}
					disabled={owner?.isAutocompleted}
					placeholder={translations.completeField}
					error={errors?.contacts?.[index]?.name}
                  />
                  <FormInput
                    mandatory
                    field="firstLastName"
                    onChangeInvestor={(value: any, field: any) =>
                      onChangeInvestor(value, field, index, "contacts")
                    }
                    value={owner?.firstLastName || ""}
                    label={translations.firstLastName}
					placeholder={translations.completeField}
					disabled={owner?.isAutocompleted}
					error={errors?.contacts?.[index]?.firstLastName}
                  />
                  <FormInput
                    field="secondLastName"
                    onChangeInvestor={(value: any, field: any) =>
                      onChangeInvestor(value, field, index, "contacts")
                    }
                    value={owner?.secondLastName || ""}
                    label={translations.secondLastName}
					disabled={owner?.isAutocompleted}
					placeholder={translations.completeField}
                  />
                  <FormInput
                    mandatory
                    field="email"
                    onChangeInvestor={(value: any, field: any) =>
                      onChangeInvestor(value, field, index, "contacts")
                    }
                    value={owner?.email || ""}
                    label={translations.email}
					placeholder={translations.completeField}
					error={errors?.contacts?.[index]?.email}
                  />
                  <FormInput
                    field="phone"
                    onChangeInvestor={(value: any, field: any) =>
                      onChangeInvestor(value, field, index, "contacts")
                    }
                    value={owner?.phone || ""}
                    label= {translations.phone}
					placeholder={translations.completeField}
                  />
                  <FormSelect
                    field="communicationType"
                    onChangeInvestor={(value: any, field: any) =>
                      onChangeInvestor(value, field, index, "contacts")
                    }
                    value={owner?.communicationType || []}
					error={errors?.contacts?.[index]?.communicationType}
                    options={communicationTypes}
                    optionName={language}
                    optionField="en"
                    mandatory
                    label= {translations.communicationPreferences}
					placeholder={translations.selectAnOption}
                    multiple
                  />
                </div>
              </div>
            );
          })}
        {selectedInvestor?.contacts?.length === 0 && (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              translations?.noContacts}
          />
        )}
      </div>
      <Divider />
      <StepsButtons
        nextText={translations.send}
        goBackStep={goBackStep}
        advanceStep={() => advanceStep(true)}
        steps={3}
        currentStep={3}
        translations={translations}
      />
    </div>
  );
};

export default PhysicalPersonContacts;
